// 请求模块内部工具函数 - 仅供内部使用

import {
  HttpError,
  HttpErrorCode,
} from './http/types';

// ==================== 数据处理工具（内部使用）====================

/**
 * HTTP错误消息映射 - 参考 adjust web sdk 错误消息
 */
const HTTP_ERROR_MESSAGES: Record<HttpErrorCode, string> = {
  [HttpErrorCode.NO_CONNECTION]: 'No network connection',
  [HttpErrorCode.SERVER_CANNOT_PROCESS]: 'Server cannot process request',
  [HttpErrorCode.SERVER_MALFORMED_RESPONSE]: 'Server returned malformed response',
  [HttpErrorCode.SERVER_INTERNAL_ERROR]: 'Server internal error',
  [HttpErrorCode.TRANSACTION_ERROR]: 'Transaction error',
  [HttpErrorCode.TIMEOUT_ERROR]: 'Request timeout',
  [HttpErrorCode.PARSE_ERROR]: 'Failed to parse response',
  [HttpErrorCode.PROTOBUF_ERROR]: 'Failed to encode/decode protobuf',
  [HttpErrorCode.NETWORK_ERROR]: 'Network connection failed',
  [HttpErrorCode.UNKNOWN_ERROR]: 'Unknown error occurred',
  [HttpErrorCode.SKIP]: 'Skipping slower attempt',
  [HttpErrorCode.MISSING_URL]: 'Url is not provided'
};


/**
 * 检查响应是否为有效JSON
 * 内部使用：core.ts
 */
export function isValidJson(str: string): boolean {
  try {
    JSON.parse(str);
    return true;
  } catch {
    return false;
  }
}

/**
 * 检查数据是否为二进制格式
 * 内部使用：传输协议处理
 */
export function isBinaryData(data: unknown): data is Uint8Array | ArrayBuffer {
  return data instanceof Uint8Array || data instanceof ArrayBuffer;
}

/**
 * 字符串转 Uint8Array
 * 内部使用：二进制数据处理
 */
export function stringToUint8Array(str: string): Uint8Array {
  return new TextEncoder().encode(str);
}

/**
 * Uint8Array 转字符串
 * 内部使用：二进制数据处理
 */
export function uint8ArrayToString(buffer: Uint8Array): string {
  return new TextDecoder().decode(buffer);
}

/**
 * 将各种数据格式转换为字符串
 * 内部使用：响应数据处理
 */
export function decodeToString(data: string | ArrayBuffer | Uint8Array): string {
  if (typeof data === 'string') return data;
    
  const decoder = new TextDecoder('utf-8');
  if (data instanceof ArrayBuffer) {
    return decoder.decode(data);
  } else if (data instanceof Uint8Array) {
    return decoder.decode(data);
  }
  return String(data);
}

// ==================== 错误处理工具（内部使用）====================

/**
 * 创建 HTTP 错误对象
 * 内部使用：adapters.ts, http-with-retry.ts
 */
export function createHttpError(message: string, status?: number, statusText?: string): HttpError {
  const error = new Error(message) as HttpError;
  error.status = status;
  error.statusText = statusText;
  return error;
}

/**
 * 创建具有详细错误信息的HTTP错误
 * 内部使用：adapters.ts, core.ts
 */
export function createDetailedHttpError(
  code: HttpErrorCode,
  status?: number,
  statusText?: string,
  customMessage?: string
): HttpError {
  const message = customMessage || HTTP_ERROR_MESSAGES[code];
  return createHttpError(message, status, statusText);
}

// 注意：这些工具函数仅供 request 模块内部使用，不对外暴露

